<template>
    <div class="apply-type-wrap">
        <div class="form-popup-title">{{ $t('DO_YOU_HAVE_AN_ACCOUNT') }}</div>
        <div class="type-wrap-row">
            <div class="apply-type -green" @click="register">
                <img src="@/assets/img/new_account.svg" alt="" />
                <div>{{ $t('I_AM_NEW_USER') }}</div>
            </div>
            <div class="apply-type -blue" @click="login">
                <img src="@/assets/img/has_account.svg" alt="" />
                <div>{{ $t('I_HAVE_AN_ACCOUNT') }}</div>
            </div>
        </div>
        <div class="login-actions-row" @click="goBack">
            <span class="login-action">{{ $t('BUTTON_BACK') }}</span>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        login() {
            this.$emit('typeSelected', 'login')
        },
        register() {
            this.$emit('typeSelected', 'register')
        },
        goBack() {
            this.$emit('goBack')
        }
    }
}
</script>
<style lang="scss" scoped>
.apply-type-wrap {
    img {
        height: 4rem;
        margin-bottom: 1rem;
    }

    @media (max-width: 1000px) {
        width: 100%;
    }
}
.form-popup-title {
    font-size: 1.6rem;
    font-family: $input-family;
    margin-bottom: 1rem;
    color: $input;
}
.type-wrap-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 1000px) {
        width: 100%;
        flex-direction: column;
    }
}
.type-wrap-back {
    text-align: center;
    margin-top: 1rem;
    color: $accent-red;
    font-family: $input-family;

    cursor: pointer;
    transition: $ease;

    &:hover {
        transform: $translateY;
    }
}
.apply-type {
    width: 23rem;
    height: 15rem;
    border: $input-border;
    border-radius: $minimal-radius;
    background: #fff;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    &:first-of-type {
        margin-right: 0.5rem;
    }
    &:last-of-type {
        margin-left: 0.5rem;
    }

    cursor: pointer;
    transition: $ease;
    font-size: 1.4rem;

    &.-green {
        color: $accent-green;

        &:hover {
            border-color: $accent-green;
        }
    }
    &.-blue {
        color: $accent-blue;

        &:hover {
            border-color: $accent-blue;
        }
    }

    img {
        height: 7rem;
    }

    div {
        transition: $ease;
        font-family: $input-family;
        margin-top: 1rem;
    }

    @media (max-width: 1000px) {
        width: 90%;
        margin-right: 0;
        margin: 1rem 0;
    }
}
</style>
